'use client';
import o from 'prop-types';

const nullishPropType = o.oneOf([
    null,
    void 0
]);

export { nullishPropType };
